import React from 'react';
import { Post } from '../services/postService';
import Postview from './Postview';
import MatchPostview from './MatchPostview';
import { IdentidadeFeed } from '../types/identidadeFeed';
import { CurrentProfile } from '../types/profile';

interface PostRouterProps {
  post: Post;
  atletaId?: string;
  torneioId?: string;
  ligaId?: string;
  identidades?: IdentidadeFeed[];
  /** Perfil ativo derivado pela page; define a identidade padrão de interação. */
  perfilAtivo?: CurrentProfile | null;
  readOnly?: boolean;
}

/**
 * PostRouter centraliza o switch post.partida != null para evitar
 * duplicação nos quatro callers (Home, Userpage, Tournamentsingle,
 * TournamentFeed). AC-A6: a lógica de dispatch está APENAS aqui.
 */
const PostRouter: React.FC<PostRouterProps> = ({
  post,
  atletaId,
  torneioId,
  ligaId,
  identidades,
  perfilAtivo,
  readOnly,
}) => {
  // Se o post tem partida associada, renderizar o layout de recap (AC-6)
  if (post.partida) {
    return (
      <MatchPostview
        post={post}
        identidades={identidades}
        perfilAtivo={perfilAtivo}
        readOnly={readOnly}
      />
    );
  }

  // Post comum: delegar ao Postview existente com todos os props necessários
  return (
    <Postview
      key={post.id}
      id={post.id}
      avater={
        post.autorAtleta?.usuario?.imagemUrl ||
        post.autorTorneio?.avatarUrl ||
        post.autorLiga?.imagemUrl ||
        '/assets/images/avatar.jpg'
      }
      user={
        post.autorAtleta?.usuario?.nome ||
        post.autorTorneio?.nome ||
        post.autorLiga?.nome ||
        ''
      }
      time={post.criadoEm}
      des={post.texto}
      midias={post.midias}
      curtidasCount={post.curtidasCount}
      jaCurtiu={post.jaCurtido}
      comentariosCount={post.comentariosCount}
      comentarios={post.comentarios}
      username={
        post.autorAtleta?.usuario?.username ||
        post.autorTorneio?.username ||
        post.autorLiga?.username ||
        ''
      }
      postAtletaId={post.autorAtleta?.id}
      status={post.status}
      torneioId={torneioId || post.autorTorneio?.id}
      ligaId={ligaId || post.autorLiga?.id}
      identidades={identidades}
      perfilAtivo={perfilAtivo}
      readOnly={readOnly ?? false}
    />
  );
};

export default PostRouter;
